import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    overflow: scroll;
    padding-bottom: 16px;
    @media (display-mode: browser) {
      overflow: auto;
    }
    ::-webkit-scrollbar {
      width: 0px;
    }
  `,
  tag: css`
    font-family: 'Proxima Nova';
    font-size: 12px;
    color: ${colors.slate};
    & + span {
      margin-left: 8px;
    }
    & + span:before {
      content: '•';
      margin-right: 8px;
    }
  `,
};

export default styles;
